import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { resetPasswordsMasivo } from "../helpers/rutaUsuarios";

const NOMBRES_SEDE = {
  TUCUMAN: "Tucumán",
  YERBA_BUENA: "Yerba Buena",
  MIAMI: "Miami",
};

const NOMBRES_ROL = {
  ADMIN_ROLE: "Administrador",
  VENDEDOR_ROLE: "Vendedor",
  LOGISTICA_ROLE: "Logística",
  GERENCIA_ROLE: "Gerencia",
  SUPERVISOR_ROLE: "Supervisor",
  USER_ROLE: "Usuario",
  USER_CAM: "Usuario CAM",
  USER_PREV: "Usuario PREV",
};

const escaparCsv = (valor) => {
  let texto = String(valor ?? "");

  // Evita que Excel interprete el contenido como fórmula
  if (/^[=+\-@]/.test(texto)) {
    texto = `'${texto}`;
  }

  return `"${texto.replace(/"/g, '""')}"`;
};

const descargarCsv = (credenciales, sede) => {
  const encabezado = [
    "Nombres",
    "Apellidos",
    "Email",
    "Sede",
    "Rol",
    "Clave provisoria",
    "Cambiar al ingresar",
  ];

  const filas = credenciales.map((item) => [
    item.nombres || "",
    item.apellidos || "",
    item.email || "",
    NOMBRES_SEDE[item.sede] ||
      item.sede ||
      "Tucumán",
    NOMBRES_ROL[item.role] ||
      item.role ||
      "Usuario",
    item.passwordTemporal || "",
    "SI",
  ]);

  const csv = [encabezado, ...filas]
    .map((fila) =>
      fila.map(escaparCsv).join(";")
    )
    .join("\r\n");

  const alcance = sede
    ? sede.toLowerCase()
    : "todas-las-sedes";

  const fecha = new Date()
    .toISOString()
    .slice(0, 10);

  const blob = new Blob([`\uFEFF${csv}`], {
    type: "text/csv;charset=utf-8",
  });

  const url = window.URL.createObjectURL(blob);
  const enlace = document.createElement("a");

  enlace.href = url;
  enlace.download =
    `claves-provisorias-${alcance}-${fecha}.csv`;

  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();

  window.URL.revokeObjectURL(url);
};

export default function ClavesMasivas({
  sede = "",
  onComplete,
}) {
  const [procesando, setProcesando] =
    useState(false);

  const ejecutar = async () => {
    const nombreSede =
      NOMBRES_SEDE[sede] || "todas las sedes";

    const acepta = window.confirm(
      `Se cambiarán inmediatamente las claves de los usuarios activos de ${nombreSede}.\n\n` +
        "El usuario root queda excluido y las sesiones anteriores se cerrarán.\n\n" +
        "¿Desea continuar?"
    );

    if (!acepta) return;

    const texto = window.prompt(
      "Para confirmar escriba exactamente: CAMBIAR CLAVES"
    );

    if (
      String(texto || "")
        .trim()
        .toUpperCase() !== "CAMBIAR CLAVES"
    ) {
      window.alert(
        "Operación cancelada. El texto de confirmación no coincide."
      );
      return;
    }

    setProcesando(true);

    const respuesta =
      await resetPasswordsMasivo(sede);

    setProcesando(false);

    if (!respuesta?.ok) {
      window.alert(
        respuesta?.err?.message ||
          "No se pudieron generar las claves."
      );
      return;
    }

    descargarCsv(
      respuesta.credenciales || [],
      sede
    );

    window.alert(
      `Se generaron ${
        respuesta.cantidad || 0
      } claves provisorias.\n\n` +
        "El archivo CSV fue descargado. Guárdelo de forma segura."
    );

    if (typeof onComplete === "function") {
      onComplete();
    }
  };

  return (
    <Button
      type="button"
      variant="outline-warning"
      onClick={ejecutar}
      disabled={procesando}
    >
      {procesando
        ? "Generando…"
        : "Claves masivas"}
    </Button>
  );
}